import React from "react";
import { Link } from "react-router-dom";

/** Minimal markdown-lite renderer for article content: ## headings, - bullets,
 * [text](/path) internal links, and blank-line-separated paragraphs. Avoids
 * pulling in a full markdown dependency for a small, controlled content set. */
export function ArticleBody({ content }) {
  const blocks = content.split(/\n\n+/);
  return (
    <div className="prose-article space-y-5 text-[15px] text-slate-300 leading-relaxed" data-testid="article-body">
      {blocks.map((block, i) => {
        if (block.startsWith("## ")) {
          return (
            <h2 key={i} className="text-2xl font-bold text-white pt-3">
              {block.replace("## ", "")}
            </h2>
          );
        }
        const lines = block.split("\n");
        if (lines.every((l) => l.startsWith("- "))) {
          return (
            <ul key={i} className="space-y-2 list-none">
              {lines.map((l, j) => (
                <li key={j} className="flex items-start gap-2.5">
                  <span className="mt-2 h-1.5 w-1.5 rounded-full bg-blue-400 shrink-0" />
                  <span>{renderInline(l.replace(/^- /, ""))}</span>
                </li>
              ))}
            </ul>
          );
        }
        return <p key={i}>{renderInline(block)}</p>;
      })}
    </div>
  );
}

function renderInline(text) {
  const parts = [];
  const regex = /\[([^\]]+)\]\(([^)]+)\)|\*\*([^*]+)\*\*/g;
  let lastIndex = 0;
  let match;
  let key = 0;
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) parts.push(text.slice(lastIndex, match.index));
    if (match[1]) {
      parts.push(
        <Link key={key++} to={match[2]} className="text-blue-400 hover:text-blue-300 underline underline-offset-2">
          {match[1]}
        </Link>
      );
    } else if (match[3]) {
      parts.push(<strong key={key++} className="text-white font-semibold">{match[3]}</strong>);
    }
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return parts;
}
